// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Straatbeeld Online',
  api_endpoint: 'https://api.straatbeeld.online/',
  pusher: {
    broadcaster: 'pusher',
    key: '97e11b02bfecf322e6a3',
    cluster: 'eu',
    forceTLS: true,
  },
  sentry: {
    dsn: 'https://146eebc8437d9431671c83ed040b7088@o4507735602298880.ingest.de.sentry.io/4508635695284304',
    environment: 'production',
    version: version
  },
  msalConfig: {
    clientId: '24aaf461-2400-4b12-ad6a-ebbbc0fb7c67',
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: window.location.origin,
  }
};
